// src/components/home/HomeRecognition.jsx

import React from "react";
import { Link } from "react-router-dom";

import { homeRecognitionItems } from "../../data/homeData";

import "./css/HomeRecognition.css";

const HomeRecognition = () => {
  return (
    <section className="home-recognition">

      <div className="home-container">

        <div className="recognition-layout">

          <div className="recognition-heading">

            <span className="home-section-eyebrow">
              PROFESSIONAL JOURNEY
            </span>

            <h2>
              A foundation built on
              <br />
              <em>learning &amp; research.</em>
            </h2>

            <p>
              Academic learning, research and professional
              experience continue to shape the practice of
              Ayurveda at Sudhamshu.
            </p>

            <Link
              to="/about"
              className="recognition-link"
            >
              Explore the journey
              <span>→</span>
            </Link>

          </div>


          <div className="recognition-list">

            {homeRecognitionItems.map((item) => (
              <div
                className="recognition-item"
                key={item.number}
              >

                <span>
                  {item.number}
                </span>

                <div>

                  <strong>
                    {item.title}
                  </strong>

                  <p>
                    {item.description}
                  </p>

                </div>

              </div>
            ))}

          </div>

        </div>

      </div>

    </section>
  );
};

export default HomeRecognition;